var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"tag-delete-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('u-button',{attrs:{"small":"","theme":"danger-outline","type":"submit"}},[_vm._v(" Удалить тег ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }